import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { BRAND } from '@shared/constants/brand';
import { Logo } from './Logo';

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col">
      <header className="sticky top-0 z-20 border-b border-cream-300/60 bg-cream-100/85 backdrop-blur">
        <div className="mx-auto flex w-full max-w-2xl items-center justify-between px-4 py-3">
          <Link to="/" className="flex items-center gap-2 font-bold text-charcoal-900" aria-label={`${BRAND.name} 홈으로`}>
            <Logo size={28} />
            <span>{BRAND.name}</span>
          </Link>
          <span className="hidden text-xs text-charcoal-500 sm:block">{BRAND.slogan}</span>
        </div>
      </header>
      <main className="mx-auto flex w-full max-w-2xl flex-1 flex-col px-4 pb-12 pt-6">{children}</main>
      <footer className="border-t border-cream-300/60 py-6 text-center text-xs text-charcoal-500">
        <nav className="mb-2 flex justify-center gap-4" aria-label="바닥글">
          <Link to="/about" className="hover:text-charcoal-900">서비스 소개</Link>
          <Link to="/privacy" className="hover:text-charcoal-900">개인정보처리방침</Link>
          <a href={`mailto:${BRAND.contactEmail}`} className="hover:text-charcoal-900">문의</a>
        </nav>
        © {new Date().getFullYear()} {BRAND.name} · {BRAND.nameEn}
      </footer>
    </div>
  );
}
